module.exports = __webpack_public_path__ + "img/Mailbox1.1739bfdc.svg";